// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    adyen: {
        environment: 'test',
        originKey:
            'pub.v2.7614568265920033.aHR0cHM6Ly9hcHAuZ29waG90by5kZXY.d6jHlHeFcz4AH2Iga1MFLPyFeyxMaKm9ARNwtpbih7A',
    },
    fingerprintjs: {
        apiKey: '2hIKIRVUKiKeGECKncZD',
    },
    http: {
        // baseUri: 'https://api-dashboard.gophoto.pro/api',
        // baseUri: 'https://bw3kv34f53.execute-api.eu-west-1.amazonaws.com',
        // baseUri: 'http://localhost:4000/api',
        baseUri: 'https://api.dev.eu1.gophoto.dev',
        authorization: {
            headerName: 'Authorization',
            tokenPrefix: 'Bearer',
        },
    },
    linkpage: {
        rootDomain: 'gophoto.dev',
    },
    logoutUrl: null,
    production: false,
    recaptcha: {
        siteKey: '6Lf0Pt0UAAAAADX0M9HQ5wbyZTUWie3pxJRkfX_s',
    },
    regionSwitches: [],
    serverTimezone: 'UTC',
};
